import { render, staticRenderFns } from "./CowVaccination.vue?vue&type=template&id=540245e6&scoped=true&"
import script from "./CowVaccination.vue?vue&type=script&lang=js&"
export * from "./CowVaccination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540245e6",
  null
  
)

export default component.exports